<template>
  <div
    class="size-full bg-[url('@/assets/backgrounds/moneycombe_bg_texture.svg')]"
  >
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<script setup lang="ts">
import { useHead } from "@unhead/vue"
const { pageTitle } = usePageTitle()

useHead({
  title: pageTitle,
  titleTemplate: (title: string | undefined) =>
    title ? `beePaid | ${title}` : `beePaid`,
})

onMounted(() => {
  api.get("/beepaidgo/get-csrf-token/")
})
</script>

<style lang="scss">
html {
  --color-secondary: 238 124 10;
  --color-accent: 232 81 36;
}

input[type="number"] {
  appearance: textfield;
  margin: 0;
}

input[type="number"]::-webkit-inner-spin-button {
  appearance: none;
}
</style>
